import type * as React from 'react';

import type { LANGUAGES } from '@crehana/ts-types';
import type { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';

import { initializeApollo } from '@/shared/libs/apollo';

import { getI18nData } from '../../shared/utils/getI18n/getI18n';
import B2BCheckout from './B2BCheckout';
import { B2B_CHECKOUT_PAGE_KEY } from './constants';
import en from './i18n/localeEn';
import es from './i18n/localeEs';
import pt from './i18n/localePt';

type TAppProps = {
  language: LANGUAGES;
};

const App: React.FC<React.PropsWithChildren<TAppProps>> = ({ language }) => {
  return (
    <>
      <NextSeo title={`Comprar | Crehana`} />

      <B2BCheckout language={language} />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  const apolloClient = initializeApollo({
    headers: req.headers,
    pageKey: B2B_CHECKOUT_PAGE_KEY,
  });

  const i18nData = await getI18nData({
    apolloClient,
    headers: req.headers,
    pageKey: B2B_CHECKOUT_PAGE_KEY,
    defaultTranslations: {
      es,
      pt,
      en,
    },
  });

  return {
    props: {
      initializeApollo: apolloClient.cache.extract(),
      ...i18nData,
    },
  };
};

export default App;
